// Batch 34 · fork B — the third statement of financial position as a column (B34-6), the restatement "Regenerate needed" text
// (B34-3), the deferred tax offset option (P6-F11), EN + AR. Merged into lib/i18n.js translations (big-file rule).
export const I18N_B34B = {
  en: {
    b34b: {
      regenRestatement: "Regenerate needed — prior-year adjustments {action} ({ref}), by {by} on {at}. Existing FS versions are kept read-only.",
      posted: "posted",
      voided: "voided",
      thirdShownAsColumn: "Shown as the third column of the statement of financial position.",
      presTitle: "Presentation options",
      offsetDt: "Offset deferred tax assets and liabilities (same tax authority, legally enforceable right)",
      offsetDtHint: "When on, the deferred tax asset and the deferred tax liability are shown as one net line on the statement of financial position, and the deferred tax notes say so.",
      saved: "Presentation options saved.",
      FS_PRESENTATION_EQ_REVIEWER_READ_ONLY: "You are the appointed engagement quality reviewer of this engagement — the presentation options are read-only for you.",
    },
  },
  ar: {
    b34b: {
      regenRestatement: "يلزم إعادة الإنشاء — {action} تسويات السنة السابقة ({ref})، بواسطة {by} في {at}. تُحفَظ النسخ الحالية للقوائم للقراءة فقط.",
      posted: "رُحّلت",
      voided: "أُلغيت",
      thirdShownAsColumn: "تُعرض في العمود الثالث من قائمة المركز المالي.",
      presTitle: "خيارات العرض",
      offsetDt: "مقاصة أصول والتزامات الضريبة المؤجلة (الجهة الضريبية نفسها، حق قانوني نافذ)",
      offsetDtHint: "عند التفعيل يُعرض أصل الضريبة المؤجلة والتزامها كبند صافٍ واحد في قائمة المركز المالي، وتذكر إيضاحات الضريبة المؤجلة ذلك.",
      saved: "حُفظت خيارات العرض.",
      FS_PRESENTATION_EQ_REVIEWER_READ_ONLY: "أنت مراجع جودة الارتباط المعيَّن لهذا الارتباط — خيارات العرض للقراءة فقط بالنسبة لك.",
    },
  },
};

export default I18N_B34B;
